// Active campaign forms
'use strict';
var twentyninetimes = twentyninetimes || {};
let redirectDomain = 'show.jsworldmedia.com';
let redirectCountryCode = 'WM';
let redirectUrl = 'https://' + redirectDomain + '/meeting/' + redirectCountryCode + '/';

twentyninetimes.myPresentation = twentyninetimes.myPresentation || function () {
	function init() {
        const myPresentationTriggerDesktop = document.getElementById('js-my-presentation-trigger-desktop');
        const myPresentationTriggerMobile = document.getElementById('js-my-presentation-trigger-mobile');
        
        // Desktop
        if(myPresentationTriggerDesktop) {
            const myPresentationDesktop = document.getElementById('js-my-presentation-desktop');
            const myPresentationDesktopForm = myPresentationDesktop.querySelector('form');

            myPresentationTriggerDesktop.addEventListener('click', function(e) {
                e.preventDefault();
                myPresentationDesktop.classList.toggle('visible');
            });
            
            myPresentationDesktopForm.addEventListener('submit', function(event) {
                event.preventDefault();
                submitForm(event.currentTarget);
            });
        }
        
        // Mobile
        if(myPresentationTriggerMobile) {
            const myPresentationMobile = document.getElementById('js-my-presentation-mobile');
            const myPresentationMobileForm = myPresentationMobile.querySelector('form');

            myPresentationTriggerMobile.addEventListener('click', function(e) {
                e.preventDefault();
                const myPresentationMobile = document.getElementById('js-my-presentation-mobile');
                myPresentationMobile.classList.toggle('visible');
            });

            myPresentationMobileForm.addEventListener('submit', function(event) {
                event.preventDefault();
                submitForm(event.currentTarget);
            });
        }
	}

    function submitForm(theForm) {
        const formParent = theForm.parentNode;
        const currentLanguage = formParent.getAttribute('data-current-language');
        const inputValue = theForm.querySelector('.my-presentation-code').value;

        switch (currentLanguage) {
            case 'es':
                redirectDomain = 'show.jscomunicacion.es';
                redirectCountryCode = 'ES';
                break;
            case 'da':
                redirectDomain = 'show.jsdanmark.dk';
                redirectCountryCode = 'DK';
                break;
            case 'de':
                redirectDomain = 'show.jsdeutschland.de';
                redirectCountryCode = 'DE';
                break;
            case 'nb':
                redirectDomain = 'show.jsnorge.no';
                redirectCountryCode = 'NO';
                break;
            case 'at':
                redirectDomain = 'show.jsoesterreich.at';
                redirectCountryCode = 'AT';
                break;
            case 'ch':
                redirectDomain = 'show.jsschweiz.ch';
                redirectCountryCode = 'CH';
                break;
            case 'fr':
                redirectDomain = 'show.jsschweiz.ch';
                redirectCountryCode = 'CH';
                break;
            case 'fi':
                redirectDomain = 'show.jssuomi.fi';
                redirectCountryCode = 'FI';
                break;
            case 'sv':
                redirectDomain = 'show.jssverige.se';
                redirectCountryCode = 'SE';
                break;
            default:
                redirectDomain = 'show.jsworldmedia.com';
                redirectCountryCode = 'WM';
            }

        redirectUrl = 'https://' + redirectDomain + '/meeting/' + redirectCountryCode + '/' + inputValue;
        window.open(redirectUrl, '_blank');
    }

	return {
		init : init
	};

}();